module.exports = __webpack_public_path__ + "img/product_bundling.e648c384.png";